module.exports = __webpack_public_path__ + "media/images/frontend/right-w-dc77c4ee37ea2fab458490d568039493.svg";